<template>
  <v-btn
    v-if="!isIos"
    icon
    @click="toggleFavorite"
    class="v-card__icon"
  >
    <v-icon
      large
      :color="'#fff'"
    >
      {{ icon }}
    </v-icon>
  </v-btn>
  <v-btn
    v-else
    icon
    @mouseenter="toggleFavorite"
    class="v-card__icon"
  >
    <v-icon
      large
      :color="'#fff'"
    >
      {{ icon }}
    </v-icon>
  </v-btn>
</template>

<script>
  import { mdiBookmark, mdiBookmarkOutline } from '@mdi/js'

  export default {
    name: 'FavoriteButton',

    props: {
      poi: {
        required: true,
      },
    },

    data() {
      return {
        poiIsInFavoritesList: false,
      }
    },

    computed: {
      icon() {
        if (!this.poi) return null

        const bookmark = this.poiIsInFavoritesList
          ? mdiBookmark
          : mdiBookmarkOutline

        return bookmark
      },

      isIos() {
        return this.$store.getters.isIos
      }
    },

    methods: {
      toggleFavorite() {
        this.poiIsInFavoritesList = !this.poiIsInFavoritesList

        // inverse of variable name beacuse color already toggled
        if (this.poiIsInFavoritesList) return this.addToFavorite()

        return this.removeFromFavorite()
      },
      async addToFavorite() {
        await this.$store.dispatch('addFavorite', this.poi)
      },
      async removeFromFavorite() {
        await this.$store.dispatch('removeFavorite', this.poi)
      },
    },

    mounted() {
      const { favorites } = this.$store.state.objects

      if (favorites.includes(this.poi.id)) this.poiIsInFavoritesList = true
    },
  }
</script>

<style lang="sass" scoped>
  .v-card__icon
    position: absolute
    z-index: 1
    right: 5px
    top: 5px
</style>
